module.exports = __webpack_public_path__ + "img/step10_a_basket_basic_fix_cross_bracket_screws.8e5d3805.png";